const disableAdSlots = (disableDesktopAd, disableMobileAd, adSlots) => {
    const adSlotsDisabled = {};
    for (let ad in adSlots) {
        if (adSlots.hasOwnProperty(ad)) {
            if (disableDesktopAd) {
                for (let i = 0; i < adSlots.desktop.length; i++) {
                    adSlotsDisabled[adSlots.desktop[i]] = true;
                }
            }

            if (disableMobileAd) {
                for (let i = 0; i < adSlots.mobile.length; i++) {
                    adSlotsDisabled[adSlots.mobile[i]] = true;
                }
            }
        }
    }

    return adSlotsDisabled;
};

export default disableAdSlots;
